import { Box, Typography, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useIsOnline } from '../../hooks/useIsOnline';

export default function PendingManifestsIndicator() {
  const theme = useTheme();
  const { isOnline, queueStatus, syncStatus } = useIsOnline();

  // Only show when offline and there are pending manifests, or when syncing
  if (isOnline || (queueStatus.queuedCount === 0 && !syncStatus.isSyncing)) {
    return null;
  }

  const pendingCount = queueStatus.queuedCount;
  const isSyncing = syncStatus.isSyncing;

  return (
    <Tooltip
      enterTouchDelay={0}
      title={
        <Box sx={{ p: 1 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5, color: 'white' }}>
            {isSyncing ? 'Syncing Manifests' : 'Pending Manifest Submissions'}
          </Typography>
          <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.9)', lineHeight: 1.4 }}>
            {isSyncing
              ? `Currently syncing ${syncStatus.totalToSync} manifest submission${syncStatus.totalToSync !== 1 ? 's' : ''} to the server.`
              : `${pendingCount} manifest submission${pendingCount !== 1 ? 's' : ''} will be automatically synced when your internet connection is restored.`}
          </Typography>
        </Box>
      }
      arrow
      placement="bottom"
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: 'rgba(0, 0, 0, 0.9)',
            maxWidth: 280,
            borderRadius: 2,
            boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
            border: '1px solid rgba(255, 255, 255, 0.1)'
          }
        },
        arrow: {
          sx: {
            color: 'rgba(0, 0, 0, 0.9)'
          }
        }
      }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          px: 2,
          py: 0.5,
          borderRadius: 2,
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          border: '1px solid rgba(255, 255, 255, 0.2)'
        }}>
        <Typography
          variant="body2"
          sx={{
            fontSize: '0.8rem',
            fontWeight: 500,
            color: theme.palette.primary.contrastText
          }}>
          {isSyncing
            ? `Syncing manifests: ${syncStatus.syncedCount}/${syncStatus.totalToSync}`
            : `Manifests ready to sync: ${pendingCount}`}
        </Typography>
      </Box>
    </Tooltip>
  );
}
